/** ! WARNING: DO NOT EDIT ! **
  This file is generated by graphql codegen.
  Make changes to *.graphql documents, not this file
**/
import type * as _Types from '_gql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetDivvyUUID_creditApplication_CreditApplication = { readonly __typename: 'CreditApplication', readonly salesforceCreditId: string, readonly companyDivvyUuid: string | null };

export type GetDivvyUUID_Query = { readonly __typename: 'Query', readonly creditApplication: GetDivvyUUID_creditApplication_CreditApplication | null };


export type GetDivvyUUIDVariables = _Types.Exact<{
  creditApplicationId: _Types.Scalars['ID']['input'];
}>;


export type GetDivvyUUID = GetDivvyUUID_Query;


export const GetDivvyUUIDDocument = gql`
    query GetDivvyUUID($creditApplicationId: ID!) {
  creditApplication(creditApplicationId: $creditApplicationId) {
    salesforceCreditId
    companyDivvyUuid
  }
}
    `;

/**
 * __useGetDivvyUUID__
 *
 * To run a query within a React component, call `useGetDivvyUUID` and pass it any options that fit your needs.
 * When your component renders, `useGetDivvyUUID` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDivvyUUID({
 *   variables: {
 *      creditApplicationId: // value for 'creditApplicationId'
 *   },
 * });
 */
export function useGetDivvyUUID(baseOptions: Apollo.QueryHookOptions<GetDivvyUUID, GetDivvyUUIDVariables> & ({ variables: GetDivvyUUIDVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDivvyUUID, GetDivvyUUIDVariables>(GetDivvyUUIDDocument, options);
      }
export function useGetDivvyUUIDLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDivvyUUID, GetDivvyUUIDVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDivvyUUID, GetDivvyUUIDVariables>(GetDivvyUUIDDocument, options);
        }
export function useGetDivvyUUIDSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDivvyUUID, GetDivvyUUIDVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDivvyUUID, GetDivvyUUIDVariables>(GetDivvyUUIDDocument, options);
        }
export type GetDivvyUUIDHookResult = ReturnType<typeof useGetDivvyUUID>;
export type GetDivvyUUIDLazyQueryHookResult = ReturnType<typeof useGetDivvyUUIDLazyQuery>;
export type GetDivvyUUIDSuspenseQueryHookResult = ReturnType<typeof useGetDivvyUUIDSuspenseQuery>;
export type GetDivvyUUIDQueryResult = Apollo.QueryResult<GetDivvyUUID, GetDivvyUUIDVariables>;